import { AuditMetaSchema, ProjectIdSchema, TenancySchema } from "@storytell/types";
import z from "zod";

// Operation types that can be performed on resources
const EventOpSchema = z.enum(["op.create", "op.update", "op.delete"]);

// Resource kinds that can be affected
const EventResourceKindValues = [
  "cp.assets",
  "cp.chats",
  "cp.concepts",
  "cp.grants",
  "cp.invitations",
  "cp.invitations_domains",
  "cp.invitations_users",
  "cp.label_associations",
  "cp.labels",
  "cp.messages",
  "cp.plans",
  "cp.projects",
  "cp.public_assets",
  "cp.stored_prompts",
  "cp.user_context",
  "cp.views",
] as const;

const EventResourceKindSchema = z.union([z.enum(EventResourceKindValues), z.string()]);

// Event resource containing kind, id, tenancy, audit meta, and optional domain data
const EventResourceSchema = z
  .object({
    kind: EventResourceKindSchema,
    id: z.string(),
    data: z.record(z.string(), z.unknown()).optional(),
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);

// Full event structure
export const EventSchema = z.object({
  op: EventOpSchema,
  resource: EventResourceSchema,
  occurredAt: z.string(),
});
type Event = z.infer<typeof EventSchema>;

// Params for the events endpoint
export const EventsParamsSchema = z.object({
  projectId: ProjectIdSchema,
});
export type EventsParams = z.infer<typeof EventsParamsSchema>;

// Callback types for event handling
export type EventCallback = (event: Event) => void;
export type ErrorCallback = (error: Error) => void;
export type ConnectionCallback = () => void;

// Event subscription options
export interface EventSubscriptionOptions {
  /** Bearer token for authentication */
  authToken: () => string | undefined;
  onEvent: EventCallback;
  onError?: ErrorCallback;
  onConnect?: ConnectionCallback;
  onDisconnect?: ConnectionCallback;
}

// Event subscription handle for cleanup
export interface EventSubscription {
  close: () => void;
}
